/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Risk View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './RiskView';

export const mapStateToPropsRisk = mapStateToProps;
export const mapDispatchToPropsRisk = mapDispatchToProps;

export default connect(mapStateToPropsRisk, mapDispatchToPropsRisk)(View);
